$(document).on('submit', 'form.loader', function () {
  //add ability to pass in loader element
  ht.showLoading('body');
});
$('body').on('click', 'a.loader', function () {
  //add ability to pass in loader element
  ht.showLoading('body', $(this).data('loaderHideonclick'));
});
